import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  card_form: {
    marginTop: "12px !important"
  },
  Card: {
    "&.css-1pwmz90-MuiPaper-root-MuiCard-root": {
      // width: "80%",
      // marginLeft: "6%",
      // marginRight: "6%",
      // padding: "2%",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15) !important",
    },
  },
  test: {
    "&.css-1y8ffmw-MuiTypography-root": {
      marginTop: "20px",
      marginBottom: "20px",
    },
  },
  form_body: {
    padding: "24px 24px !important",
  },
  heading: {
    "&..css-tp1jng-MuiCardHeader-root": {
      padding: "14px 24px 4px 25px",
    },
  },
  textfield: {
    "&.css-1u3bzj6-MuiFormControl-root-MuiTextField-root": {
      marginBottom: "7px",
      // width: "240px",
      "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: "white",
        },
        "&.Mui-focused": {
          backgroundColor: "white",
        },
      },
      "& .MuiFilledInput-root": {
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: "white",
        },
        "&.Mui-focused": {
          backgroundColor: "white",
        },
      },
    },
  },
  button: {
    "&.css-1sr3nc9-MuiButtonBase-root-MuiButton-root": {
      width: "20%",
      marginLeft: "10px",
    },
  },
  error: {
    color: "red",
    fontSize: "12px !important",
  },
  inputError: {
    "& .MuiFilledInput-underline": {
      borderColor: "rgb(255 0 0 / 48%) !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiFilledInput-underline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiFilledInput-underline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
  second_card: {
    marginTop: "1rem",
  },
  second_card_heading: {
    padding: "1rem 2rem 0.5rem",
  },
  second_card_sub_heading: {
    padding: "0 2rem 0.5rem",
  },
  textarea_container: {
    padding: "1rem 2rem"
  },
  copy_btn_container: {
    padding: "0.5rem 0 0.5rem 2rem",
  },
  toggle_container:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    gap:'20px',
    "& .MuiFormControlLabel-root": {
      backgroundColor: "white",
      padding: "4px 8px",
      borderRadius: "4px",
    },
  },
  toggle_container_wrap:{
    display:'flex',
    gap:"20%"
  },
}));
